module.exports = __webpack_public_path__ + "media/Man_Chat_0.02ea71d0.mp3";